import * as THREE from 'three';
import { generateUniqueId } from '../../utils/generateUniqueId';
import { drawTextFromCode } from '../../commands/drawTextFromCode';

// Kapı Otomatiği (K.O.) sembolü — interkom hattına bağlanır, yeşil.
// Geometri: sol tarafta 20×10 dörtgen (içinde "K.O.") + sağına dik üçgen
// (taban 10, yükseklik 10). Toplam alt kenar 30. Bağlantı noktası sol kenarda (x=0).

function drawKOText(rotationRad = 0) {
  const dummyScene = new THREE.Scene();
  const group = drawTextFromCode(dummyScene, {
    text: 'K.O.',
    position: { x: 10, y: 0 }, // dörtgen merkezi (0..20 → 10)
    fontSize: 7,
    color: '#ffffff',
    alignment: 'center',
    halign: 1,
    valign: 0,
    rotation: (rotationRad * 180) / Math.PI,
  });
  if (!group || !(group instanceof THREE.Object3D)) return new THREE.Group();
  return group;
}

export function createDoorOpener(scene, position, color = 0x33cc33, isPreview = false, dir = 1) {
  const group = new THREE.Group();
  const offsetGroup = new THREE.Group();
  const doorOpenerId = generateUniqueId('doorOpener');

  dir = dir ?? 1;

  group.userData = {
    id: doorOpenerId,
    type: 'doorOpener',
    isSelectable: true,
    isPreview,
    basePoint: { x: position.x, y: position.y },
    dir,
  };

  group.position.set(position.x, position.y, 0);
  group.add(offsetGroup);

  const koColor = (typeof color !== 'undefined' && color !== null) ? color : 0x33cc33;
  const material = new THREE.LineBasicMaterial({
    color: koColor,
    transparent: isPreview,
    opacity: isPreview ? 0.5 : 1,
  });

  // Dörtgen 20×10 (0..20, -5..5) — sağ kenar (x=20) üçgenle ortak
  const rectGeo = new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(0, -5, 0),
    new THREE.Vector3(0, 5, 0),
    new THREE.Vector3(20, 5, 0),
    new THREE.Vector3(20, -5, 0),
    new THREE.Vector3(0, -5, 0),
  ]);
  offsetGroup.add(new THREE.Line(rectGeo, material));

  // Dik üçgen: (20,5) → (30,-5) → (20,-5). Alt kenar 20..30, hipotenüs köşegen.
  const triGeo = new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(20, 5, 0),
    new THREE.Vector3(30, -5, 0),
    new THREE.Vector3(20, -5, 0),
  ]);
  offsetGroup.add(new THREE.Line(triGeo, material));

  // "K.O." yazısı (dörtgen içinde ortalı)
  const baseAngle = (dir instanceof THREE.Vector3) ? Math.atan2(dir.y, dir.x) : 0;
  const label = drawKOText(baseAngle);
  label.traverse(child => {
    if (child.material && child.material.color) child.material.color.set(koColor);
  });
  offsetGroup.add(label);

  // Yön kontrolü (zil butonu deseni)
  if (typeof dir === 'number') {
    offsetGroup.scale.set(1, dir, 1);
  }
  if (dir instanceof THREE.Vector3) {
    group.rotation.z = baseAngle;
  }

  if (scene && !isPreview) {
    scene.add(group);
  }

  return group;
}
